<template>
  <span
    class="flex items-center gap-1 whitespace-nowrap"
    v-if="Boolean(props.flags.length)"
  >
    <span
      v-if="props.showCount"
      class="text-xs bg-red-400 group-hover:bg-gray-100 group-hover:text-gray-700 text-gray-100 rounded-full w-5 h-5 flex items-center justify-center"
    >
      {{ props.flags.length }}
    </span>
    <FlagIcon
      :size="FLAG_ICON_SIZE"
      class="text-red-400 shrink-0"
    />
    <span class="text-red-400 text-sm font-semibold text-ellipsis overflow-hidden">{{ props.flags.join(', ') }}</span>
  </span>
</template>

<script setup>
import { FlagIcon, FLAG_ICON_SIZE } from '@/Components/Flags'

const props = defineProps({
  flags: {
    type: Array,
    required: false,
    default: () => []
  },
  showCount: {
    type: Boolean,
    required: false,
    default: false
  }
})
</script>
